<template>
  <van-popup
      :value="showPopup"
      position="bottom"
      @input="showPopup = $event"
      closeable
      style="border-top-left-radius: 16px; border-top-right-radius: 16px;"
  >
    <h3 class="title">{{ $t(`语言`) }}</h3>
    <div class="container">
      <div class="languageItem"
           v-for="(item, index) in languageList"
           :key="index"
           @click="changeLanguage(item)"
           :class="[$store.state.language === item.code ? 'active' : '']">{{item.name}}</div>
    </div>
  </van-popup>
</template>
<script>
import { Popup } from 'vant';
export default {
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      showPopup: false,
      languageList: [
        {
          name: '简体中文',
          code: 'zh-CN'
        },
        {
          name: '繁体中文',
          code: 'zh-TW'
        },
        {
          name: 'English',
          code: 'en-US'
        }
      ]
    }
  },
  methods: {
    changeLanguage(item) {
      console.log(item)
      this.$i18n.locale = item.code;
      this.$store.dispatch('changeLanguage', item.code)
      this.showPopup = false;
    }
  }
}
</script>

<style scoped lang="less">
.title{
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-align: center;
  padding: 18px 0;
}
.container{
  display: grid;
  grid-auto-flow: row;
  gap: 2px;
  padding-bottom: 30px;
}
.languageItem{
  padding: 14px 20px;
  &.active{
    color: #29D769;
  }
}
</style>
